import _ from "underscore";
import SelectionTree from "./SelectionTree";
import TriStateSelectionController from "../tree/TriStateSelectionController";

export default function TriStateSelectorTree(rootNode, emptyMessageBuilder, collapsedNodeIds)
{
    SelectionTree.call( this, rootNode, false, collapsedNodeIds );
    this.emptyMessageBuilder = emptyMessageBuilder;
}

TriStateSelectorTree.prototype = _.create(SelectionTree.prototype);

TriStateSelectorTree.prototype.createSelectionController = function()
{
    return new TriStateSelectionController( this );
};

TriStateSelectorTree.prototype.createMessagePanel = function( content, styleClass )
{
    var table = document.createElement( "table" );
    table.className = "selectorMessage " + styleClass;
    var tBody = document.createElement( "tbody" );
    var tr = document.createElement( "tr" );
    var td = document.createElement( "td" );

    table.appendChild( tBody );
    tBody.appendChild( tr );
    tr.appendChild( td );
    td.innerHTML = content;
    return table;
};

TriStateSelectorTree.prototype.decorateTreePanel = function(treePanel)
{
    SelectionTree.prototype.decorateTreePanel.call( this );

    var emptyMessages = this.emptyMessageBuilder.processEmptyMessages();

    for (var key in emptyMessages)
    {
        //noinspection JSUnfilteredForInLoop
        treePanel.appendChild(this.createMessagePanel(emptyMessages[key], key));
    }

    return treePanel;
};

TriStateSelectorTree.prototype.getVisibleNodeSet = function(nodeSet)
{
    return (this.hasActiveFilter()) ? this.getActiveFilter().getVisibleNodeSet(nodeSet) : nodeSet.clone();
};

TriStateSelectorTree.prototype.isSelectionChanged = function()
{
    //abstract
};

TriStateSelectorTree.prototype.selectAll = function()
{
    if( this.isRootVisible() )
        this.getSelectionController().selectSubtree( this.getRootNode(), true );
    else
        this.getSelectionController().selectChildrenInDepth( this.getRootNode(), true );
};

TriStateSelectorTree.prototype.resetNodes = function( nodeSet )
{
    this.deselectAll();
    this.getSelectionController().resetSelectedNodes( nodeSet );
    this.getSelectionController().updateUI();
};

TriStateSelectorTree.prototype.initializeByNodeSet = function( nodeSet )
{
    this.deselectAll();
    this.getSelectionController().initializeByNodeSet( nodeSet );
    this.getSelectionController().resetSelectedNodes();
    this.getSelectionController().updateUI();
};


// WEBPACK FOOTER //
// ./web/js/hierarchySelector/selectionTree/TriStateSelectorTree.js